module.exports = __webpack_public_path__ + "img/Arly_Logo_Cream2.231b0a71.svg";